<template>
  <div>
    <confirmation-dialog
      hide-open-button
      message-title="REMOVER VALOR"
      message-body="TEM CERTEZA QUE DESEJA REMOVER O VALOR?"
      @yes="evOnRemoveValueAccepted"
      v-model="showRemoveDialog"
    />

    <b-modal
      title="NOVO TIPO DE HOSPEDAGEM"
      size="xl"
      id="new_type_of_hosting"
      no-close-on-backdrop
      hide-footer
      @show="evOnShow"
      @shown="evOnShown"
      @hide="evOnHide"
    >
      <b-form @submit.prevent="evOnSubmit">
        <div class="row m-0">
          <div class="col-md-12 v-clean">
            <h1 class="title-pages">INFORMAÇÕES</h1>
            <div class="row">
              <div class="col-md-6">
                <label-required-field label="Tipo de cobrança" />
                <b-select v-model="billing_type_of_hosting_type_id">
                  <b-select-option value>SELECIONE...</b-select-option>
                  <b-select-option
                    v-for="value in billing_type_of_hosting_types"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ value.name }}
                  </b-select-option>
                </b-select>
              </div>
              <div class="col-md-6">
                <label-required-field label="Nome" />
                <b-input type="text" ref="name" v-model="name" />
              </div>
            </div>
          </div>
          <div class="col-md-12 v-clean mt-2">
            <h1 class="title-pages">ADICIONAR VALORES</h1>
            <div class="row">
              <div class="col-md-12">
                <b-row align-v="end">
                  <b-col>
                    <label-required-field label="Valor" />
                    <b-input
                      type="text"
                      ref="value"
                      v-model="value"
                      @keyup="handleValue"
                    />
                  </b-col>
                  <b-col>
                    <label>Descrição</label>
                    <b-input type="text" v-model="description" />
                  </b-col>
                  <b-col cols="auto">
                    <v-btn @click="createHostingTypeValueTmp" class="btn-add">
                      <i class="fas fa-check mr-2 text-twenty"></i>
                      ADICIONAR
                    </v-btn>
                  </b-col>
                </b-row>
              </div>
              <div class="col-md-12">
                <h1 class="title-pages">VALORES</h1>
                <div
                  class="v-clean p-5 text-center"
                  v-show="hostingTypeValueTmp.length == 0"
                >
                  <h6 class="text-center upper-text worksansr">
                    SEM RESULTADOS!
                  </h6>
                </div>
                <v-data-table
                  v-show="hostingTypeValueTmp.length > 0"
                  dense
                  :headers="headers"
                  :items="hostingTypeValueTmp"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      small
                      @click="prepareToRemoveValue(item)"
                      class="btn-delete m-1"
                    >
                      <i class="fas fa-trash mr-2 text-twenty"></i>
                      REMOVER
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <warning-required-fields />
            <errors-messages :errors="errors" />
          </div>
        </div>
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn :disabled="loading" type="submit" class="btn-save">
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "Carregando" : "SALVAR" }}
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { formatValueOnKeyUp, formatValueToOnlyNumber } from "../../lib/format";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ConfirmationDialog from "../Components/ConfirmationDialog.vue";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "NewTypeOfHosting",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      loading: false,

      showRemoveDialog: false,
      removeTarget: null,

      headers: [
        { text: "VALOR", value: "value" },
        { text: "DESCRIÇÃO", value: "description" },
        {
          text: "AÇÕES",
          value: "actions",
          sortable: false,
        },
      ],

      billing_type_of_hosting_types: [],
      billing_type_of_hosting_type_id: "",
      name: "",
      value: "",
      description: "",
      hostingTypeValueTmp: [],
    };
  },

  created() {
    this.evOnCreated();
  },

  methods: {
    async evOnCreated() {
      await this.getBillingTypeOfHostingTypes();
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.showRemoveDialog = false;
      this.removeTarget = null;

      this.billing_type_of_hosting_type_id = "";
      this.name = "";
      this.value = "";
      this.description = "";
      this.hostingTypeValueTmp = [];
    },

    async evOnShown() {
      this.$refs.name.focus();
    },

    async evOnHide() {},

    prepareToRemoveValue(item) {
      this.removeTarget = item;
      this.showRemoveDialog = true;
    },

    evOnRemoveValueAccepted() {
      this.hostingTypeValueTmp = this.hostingTypeValueTmp.filter(
        (item) => item.id !== this.removeTarget.id
      );
    },

    handleValue: function (e) {
      this.value = formatValueOnKeyUp(e.target.value);
    },

    createHostingTypeValueTmp() {
      this.errors = [];

      if (!this.value) this.errors.push("Informe o valor");

      if (parseInt(formatValueToOnlyNumber(this.value)) < 0)
        this.errors.push("Informe o valor acima de 0");

      if (this.errors.length > 0) {
        this.$refs.value.focus();
        return;
      }

      let id = formatValueToOnlyNumber(new Date().toISOString());

      this.hostingTypeValueTmp.push({
        id: `${Math.floor(Math.random() * 1024)}${id}`,
        value: this.value,
        description: this.description,
      });

      this.value = "";
      this.description = "";

      this.$refs.value.focus();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          billing_type_of_hosting_type_id: this.billing_type_of_hosting_type_id,
          name: this.name,
          hostingTypeValueTmp: this.hostingTypeValueTmp,
        };
        const response = await api.post(
          "/rest-home/type-of-hosting/create",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new_type_of_hosting");
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getBillingTypeOfHostingTypes() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/type-of-hosting/types");
        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.billing_type_of_hosting_types = types;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>